import { render } from "./RegistryConfigs.vue?vue&type=template&id=fd674e5a"
import script from "./RegistryConfigs.vue?vue&type=script&lang=js"
export * from "./RegistryConfigs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__